import * as FiIcons from 'react-icons/fi';
import * as SiIcons from 'react-icons/si';
import SafeIcon from '../common/SafeIcon';

const icons = {
  instagram: SiIcons.SiInstagram,
  threads: SiIcons.SiThreads,
  tiktok: SiIcons.SiTiktok,
  youtube: SiIcons.SiYoutube,
  facebook: SiIcons.SiFacebook,
  linkedin: FiIcons.FiLinkedin,
  vimeo: SiIcons.SiVimeo,
  blog: FiIcons.FiBookOpen,
  xiaohongshu: SiIcons.SiXiaohongshu || FiIcons.FiBookOpen,
  weibo: SiIcons.SiSinaweibo
};

export default function SocialIcon({ name, ...props }) {
  return <SafeIcon icon={icons[name] || FiIcons.FiExternalLink} {...props} />;
}